import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Analytics } from '@vercel/analytics/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initMetaPixel } from './metaPixel';

// Errors only — no tracing, no session replay. Those are separate integrations
// and neither is enabled here; this is a crash reporter, not an APM.
//
// The DSN is a PUBLIC key. It ships in the browser bundle by design and is
// write-only: it can submit an event to this project and nothing else. It is
// still read from the environment rather than inlined, so it can be rotated or
// pointed at a different project without a code change.
//
// Disabled outside production so local dev and any preview build never report.
// `enabled` is evaluated once at init, and with no DSN set it is false anyway —
// the NODE_ENV check is the deliberate half, the DSN check the safety net.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  enabled: Boolean(process.env.REACT_APP_SENTRY_DSN) && process.env.NODE_ENV === 'production',
  sendDefaultPii: false,
});

// Load the Meta Pixel once (no-op until a Pixel ID is set in src/metaPixel.js).
initMetaPixel();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{padding:24}}>Something went wrong. Refresh the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
    {/* Vercel Web Analytics. A sibling of the error boundary, not of App, so
        it keeps reporting when App crashes into the fallback. */}
    <Analytics />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
